import React from 'react';
import { Box, Card, CardContent, Typography, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CompanyLoginForm } from '../../components/Auth/CompanyLoginForm';

export const CompanyLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleForgotPassword = () => {
    navigate('/auth/forgot-password');
  };

  const handleRegister = () => {
    navigate('/company/register');
  };

  const handleStudentLogin = () => {
    navigate('/auth/login');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          maxWidth: { xs: '100%', sm: '480px', md: '520px', lg: '560px' },
          width: '100%',
        }}
      >
        <Card
          elevation={8}
          sx={{
            borderRadius: { xs: 2, sm: 3, md: 4 },
            overflow: 'hidden',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
            width: '100%',
            maxWidth: '100%',
          }}
        >
          <CardContent sx={{ p: { xs: 3, sm: 4, md: 5, lg: 6 } }}>
            {/* ヘッダー */}
            <Box
              sx={{
                textAlign: 'center',
                mb: { xs: 3, sm: 4 },
                position: 'relative',
              }}
            >
              {/* タイトル */}
              <Typography
                variant="h3"
                component="h1"
                sx={{
                  fontWeight: 'bold',
                  background:
                    'linear-gradient(45deg, #667eea 30%, #764ba2 90%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  mb: 2,
                  fontSize: 'clamp(1.3rem, 6vw, 2rem) !important',
                  letterSpacing: '-0.01em',
                  whiteSpace: 'nowrap',
                }}
              >
                ガクフドキャリア
              </Typography>

              {/* サブタイトル */}
              <Typography
                variant="h6"
                sx={{
                  color: '#374151',
                  fontWeight: 500,
                  mb: 1,
                  fontSize: 'clamp(1rem, 4vw, 1.3rem) !important',
                  letterSpacing: '-0.01em',
                  whiteSpace: 'nowrap',
                }}
              >
                企業ログイン
              </Typography>
            </Box>

            {/* ログインフォーム */}
            <CompanyLoginForm
              onForgotPassword={handleForgotPassword}
              onRegister={handleRegister}
              onStudentLogin={handleStudentLogin}
            />

            {/* フッター */}
            <Box
              sx={{
                textAlign: 'center',
                mt: { xs: 3, sm: 4 },
                pt: { xs: 2, sm: 3 },
                borderTop: '1px solid #E5E7EB',
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  color: '#9CA3AF',
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                }}
              >
                © {currentYear} ガクフドキャリア. All rights
                reserved.
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};
